// Errori di verifica OTP del server (in inglese) mostrati con un testo chiaro e il prossimo passo.
const OTP_FAILURES = /invalid otp|session expired|too many failed attempts|otp has already been used/i;

export const withOtpMessage = (request) =>
  request.catch((failure) => {
    if (OTP_FAILURES.test(failure?.response?.data?.message || ''))
      failure.response.data = { ...failure.response.data, message: 'Codice non valido o scaduto: richiedine uno nuovo' };
    throw failure;
  });
